
import { ToastContainer } from 'react-toastify';
import './App.css';
import 'react-toastify/dist/ReactToastify.css';
import Aviator from './components/aviator';
import SVGs from './components/svgs'
import AviatorProvider from './store/aviator'
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { SnackbarProvider } from 'notistack';
function App() {
  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <SVGs />
      <SnackbarProvider
        maxSnack={3}
        // Components={{
        //   cashout: CashoutSnackBar,
        // }}
      >
        <AviatorProvider>
          <BrowserRouter basename={process.env.PUBLIC_URL || "/games/crash-new"}>
            <Routes>
              <Route path="*" element={<Aviator />} />
            </Routes>
          </BrowserRouter>
        </AviatorProvider>
      </SnackbarProvider>
    </>
  );
}

export default App;
